import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";
import ListRoadSinister from "../pages/RoadSinisters/Index";
import ReassignRoadSinister from "../pages/RoadSinisters/Reassignation";
import RoadSinisterFile from "../pages/RoadSinisters/File/Index";
import ConceptsValidation from "@/pages/RoadSinisters/File/ConceptsValidation/";
import Lifting from "@/pages/RoadSinisters/File/Lifting/index";
import CloseProject from "@/pages/RoadSinisters/CloseProject/index";

const RegisterRoadSinister = () =>
  import("../pages/RoadSinisters/Register/Index");
const RoadSinisterQuantification = () =>
  import("../pages/RoadSinisters/File/Quantification/index");
const Budget = () => import("../pages/RoadSinisters/File/Budget");

import moment from "moment";

const roadSinistersPages = {
  path: "/",
  component: DashboardLayout,
  name: "roadSinistersPages",
  customIcon: "fa fa-road",
  title: "Siniestros Carreteros",
  excludedRoles: ["EXCLI", "IDEAL"],
  meta: {
    ifUserCan: {
      view: "Roads/sinisterroads",
    },
  },
  excludedGroups: ["Extranet"],
  children: [
    {
      path: "/siniestros/carreteros",
      name: "Siniestros Carreteros",
      title: "Listado",
      component: ListRoadSinister,
      // excludedRoles: ['EXCLI', 'IDEAL'],
      meta: {
        ifUserCan: {
          view: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/pendientes-validacion-comercial",
      name: "Siniestros Carreteros Pendientes Validacion Comercial",
      title: "Siniestros Pendientes de Validación Comercial",
      // roles: ['KAM'],
      meta: {
        // :TODO: Confirm sinisterroads permission
        ifUserCan: {
          view_validation_sinisters: "Roads/sinisterroads",
        },
      },
      props: () => ({
        showTableActions: false,
        process: "recepcion-de-siniestro",
        dateFilter: "add_date",
        filterDefaults: {
          dateFrom: moment().subtract(15, "days").format("YYYY-MM-DD"),
          dateTo: null,
        },
      }),
      component: ListRoadSinister,
    },
    {
      path: "/siniestros/carreteros/reasignacion",
      name: "Reasignacion Siniestros Carreteros",
      title: "Reasignacion de Siniestros",
      component: ReassignRoadSinister,
      roles: ["ADMIN", "GECA"],
    },
    {
      path: "/siniestros/carreteros/nuevo",
      name: "Registrar Siniestro Carretero",
      title: "Registrar",
      component: RegisterRoadSinister,
      meta: {
        ifUserCan: {
          add: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/editar/:id",
      props: true,
      name: "Editar Siniestro Carretero",
      component: RegisterRoadSinister,
      meta: {
        // excludedRoles: ['EXCLI', 'IDEAL'],
        ifUserCan: {
          change: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id",
      props: true,
      name: "Ficha de Siniestro Carretero",
      component: RoadSinisterFile,
      // :TODO: apply parent permission
      meta: {
        ifUserCan: {
          view: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/cliente/:id",
      props: ({ params }) => ({
        id: params.id,
        extranetSinister: true,
      }),
      name: "Ficha de Siniestro Carretero Cliente",
      component: RoadSinisterFile,
      meta: {
        ifUserCan: {
          extranet_view: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/cuantificacion",
      props: true,
      name: "Cuantificación de siniestro carretero",
      component: RoadSinisterQuantification,
      meta: {
        ifUserCan: {
          view: "Quantification/quantification",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/cierre-proyecto",
      props: (r) => ({
        mode: "normal",
        id: r.params.id,
      }),
      name: "Cierre de Proyecto",
      component: Budget,
      meta: {
        ifUserCan: {
          view: "Quantification/quantification",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/validacion-conceptos",
      props: true,
      name: "ConceptsValidation",
      component: ConceptsValidation,
      meta: {
        // :TODO: Define permission
        ifUserCan: {
          view_concept_validation: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/cuantificacion/:quotation/levantamiento",
      props: (r) => ({
        mode: "full",
        id: r.params.id,
        quotation: r.params.quotation,
      }),
      name: "Levantamiento",
      component: Lifting,
      meta: {
        ifUserCan: {
          view: "Quantification/quantificationconcept",
          view_lifting: "Roads/sinisterroads",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/requerimientos_cierre_de_proyecto",
      props: (r) => ({
        mode: "full",
        id: r.params.id,
      }),
      name: "Requerimientos de Cierre de Proyecto",
      component: CloseProject,
      meta: {
        ifUserCan: {
          view: "Quantification/closeprojectvalidations",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/presupuesto",
      props: (r) => ({
        mode: "full",
        id: r.params.id,
      }),
      name: "Presupuesto de siniestro carretero",
      component: Budget,
      meta: {
        ifUserCan: {
          view: "Quantification/quantification",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/presupuesto/materiales",
      props: (route) => ({
        mode: "materials",
        id: route.params.id,
      }),
      // roles: ['ATES', 'GEFI', 'GECA', 'AUXADMIN', 'AUDITOR'],
      name: "Presupuesto de siniestro carretero (materiales)",
      component: Budget,
      meta: {
        ifUserCan: {
          view: "Quantification/quantification",
        },
      },
    },
    {
      path: "/siniestros/carreteros/:id/presupuesto/servicios",
      props: (route) => ({
        mode: "services",
        id: route.params.id,
      }),
      // roles: ['ATES', 'GEFI', 'GECA', 'AUXADMIN', 'AUDITOR'],
      name: "Presupuesto de siniestro carretero (servicios)",
      component: Budget,
      meta: {
        ifUserCan: {
          view: "Quantification/quantification",
        },
      },
    },
  ],
};

export default roadSinistersPages;



// WEBPACK FOOTER //
// ./src/router/sinisterRoutes.js